import Actions from 'flow/actions';
import RecordedCallsResource from 'flow/api/recordedcalls';
import TranscriptionResource from 'flow/api/transcription';
import { networkErrorDispatcher } from 'flow/actions/app-actions';
import { queryClient } from 'flow/contexts/query-client';
import { AppDispatch } from 'flow/types/Redux';
import {
    CallRecordKey,
    ExtendedTranscriptionKey,
    RecordedCallKey,
} from 'flow/types/EntityKeys';
import { Callback } from 'flow/types/HomeClient';
import { TranscriptionState } from 'flow/types/RecordedCalls';

export const createRecordedCallTranscription =
    (recordedCallKey: RecordedCallKey, isPersonalRecording: boolean) =>
    (dispatch: AppDispatch) => {
        return new Promise((resolve, reject) => {
            RecordedCallsResource.createTranscriptionAsync(
                {
                    onResult: resolve,
                    onError: (error) => {
                        dispatch(
                            setTranscriptionInProgress(
                                recordedCallKey,
                                TranscriptionState.Failed,
                            ),
                        );
                        networkErrorDispatcher(dispatch);
                        reject(error);
                    },
                    onClientError: (error) => {
                        dispatch(
                            setTranscriptionInProgress(
                                recordedCallKey,
                                TranscriptionState.Failed,
                            ),
                        );
                        reject(error);
                    },
                } as Callback,
                recordedCallKey,
                {
                    personalRecording: isPersonalRecording,
                },
            );
        });
    };

export const setTranscriptionInProgress = (
    recordedCallKey: RecordedCallKey,
    transcriptionState: TranscriptionState,
) => ({
    type: Actions.RESULT_CALL_RECORDING_TRANSCRIPTION_PROGRESS,
    recordedCallKey,
    transcriptionState,
});

export const deletePersonalRecordedCall =
    (recordedCallKey: RecordedCallKey, callRecordKey: CallRecordKey) =>
    (dispatch: AppDispatch) => {
        RecordedCallsResource.deletePersonalRecordedCall(
            {
                onResult: () => {
                    dispatch({
                        type: Actions.RESULT_DELETE_PERSONAL_RECORDED_CALL,
                        callRecordKey,
                    });
                },
                onError: networkErrorDispatcher(dispatch),
            } as Callback,
            recordedCallKey,
        );
    };

export const deleteTranscription =
    (
        extendedTranscriptionKey: ExtendedTranscriptionKey,
        callRecordKey: CallRecordKey,
        isPersonal: boolean,
    ) =>
    (dispatch: AppDispatch) => {
        TranscriptionResource.deleteTranscription(
            {
                onResult: () => {
                    dispatch({
                        type: Actions.RESULT_DELETE_TRANSCRIPTION,
                        callRecordKey,
                    });
                    queryClient.removeQueries({
                        queryKey: [
                            'extendedTranscription',
                            extendedTranscriptionKey,
                        ],
                    });
                },
                onError: networkErrorDispatcher(dispatch),
            } as Callback,
            extendedTranscriptionKey,
            isPersonal,
        );
    };
